/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCollectionsComponents_user = {
    readonly canShowSellerName: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"TradePromo_user" | "SbRespNullSearchResults_user" | "SharedRecentlyViewedItems_user" | "SbRespMainContent_user">;
    readonly " $refType": "SbRespCollectionsComponents_user";
};
export type SbRespCollectionsComponents_user$data = SbRespCollectionsComponents_user;
export type SbRespCollectionsComponents_user$key = {
    readonly " $data"?: SbRespCollectionsComponents_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsComponents_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canShowSellerName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_user",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_user",
      "args": null
    }
  ]
};
(node as any).hash = 'ea6af2f3d28f56660f9cf4cf8e7a4669';
export default node;
